<template>
    <el-dialog :visible.sync="visible" :title="调整会员所属区域" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="名称" prop="mobile">
                <el-input v-model="dataForm.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item prop="parentId" :label="所属区域" class="org-list">
                <el-popover v-model="orgListVisible" ref="orgListPopover" placement="bottom-start" trigger="click">
                    <el-tree
                            :data="orgList"
                            :props="{ label: 'orgName', children: 'children' }"
                            node-key="id"
                            ref="orgListTree"
                            :highlight-current="true"
                            :expand-on-click-node="false"
                            accordion
                            @current-change="orgListTreeCurrentChangeHandle">
                    </el-tree>
                </el-popover>
                <el-input v-model="dataForm.orgName" v-popover:orgListPopover :readonly="true"
                          :placeholder="$t('org.orgName')"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" :disabled="isDisabled" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                isDisabled: false,
                orgList: [],
                orgListVisible: false,
                dataForm: {
                    id: '',
                    name: '',
                    mobile: '',
                    orgName:'',
                    orgId:'',
                    oldOrgId:''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    nick: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    avatar: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id,name,mobile,orgId,orgName) {
                this.visible = true
                this.$nextTick(() => {
                    this.dataForm.id = id
                    this.dataForm.name=name
                    this.dataForm.mobile=mobile
                    this.dataForm.orgId=orgId
                    this.dataForm.orgName=orgName
                    this.dataForm.oldOrgId=orgId
                    this.getOrgList();
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/list').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            },
            // 上级组织机构选中
            orgListTreeCurrentChangeHandle(data, node) {
                this.dataForm.orgId = data.id
                this.dataForm.orgName = data.orgName
                this.orgListVisible = false
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                if(!this.isDisabled) {
                    this.isDisabled=true;
                }
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        this.isDisabled=false;
                        return false
                    }
                    if(this.dataForm.oldOrgId==this.dataForm.orderId) {
                        this.isDisabled=false;
                        return this.$message.error("请选择新所属区域");
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('pms/umsmember/changMemberOrg', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            this.isDisabled=false;
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                        this.isDisabled=false;
                    }).catch(() => {
                        this.isDisabled=false;
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
